import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Bell, MapPin, MessageSquare, Search, FileX } from 'lucide-react';
import { Button } from '../ui/button';

const EmptyState = ({ 
  type = 'default',
  title,
  description,
  action,
  actionLabel,
  icon: CustomIcon
}) => {
  const configs = {
    default: {
      icon: FileX,
      title: 'No Data Found',
      description: 'There is no data to display at this time.',
    },
    alerts: {
      icon: Bell,
      title: 'No Alerts',
      description: 'There are no emergency alerts at this time. You will be notified when new alerts are issued.',
    },
    'map-items': {
      icon: MapPin,
      title: 'No Map Items',
      description: 'No road closures, detours, or incidents to display. The roads are clear!',
    },
    messages: {
      icon: MessageSquare,
      title: 'No Messages',
      description: 'Start a conversation by sending a message.',
    },
    search: {
      icon: Search,
      title: 'No Results Found',
      description: 'Try adjusting your search or filter criteria.',
    },
    incidents: {
      icon: AlertTriangle,
      title: 'No Active Incidents',
      description: 'All clear! There are no active incidents in the area.',
    },
  };

  const config = configs[type] || configs.default;
  const Icon = CustomIcon || config.icon;
  const displayTitle = title || config.title;
  const displayDescription = description || config.description;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center py-12 px-4 text-center"
    >
      <div className="w-16 h-16 rounded-full bg-zinc-800 flex items-center justify-center mb-4">
        <Icon className="w-8 h-8 text-zinc-600" />
      </div>
      <h3 className="text-lg font-semibold text-white mb-2">{displayTitle}</h3>
      <p className="text-zinc-500 text-sm max-w-sm mb-4">{displayDescription}</p>
      {action && actionLabel && (
        <Button onClick={action} className="bg-red-500 hover:bg-red-600 text-white">
          {actionLabel}
        </Button>
      )}
    </motion.div>
  );
};

export default EmptyState;
